function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*! Cropper.js v2.1.0 | (c) 2015-present Chen Fengyuan | MIT */
import { isString, isElement, getRootDocument, CROPPER_IMAGE, CROPPER_CANVAS, CROPPER_SELECTION } from '@cropper/utils';
export * from '@cropper/utils';
import { CropperCanvas, CropperCrosshair, CropperGrid, CropperHandle, CropperImage, CropperSelection, CropperShade, CropperViewer } from '@cropper/elements';
export * from '@cropper/elements';
var DEFAULT_TEMPLATE = '<cropper-canvas background>' + '<cropper-image rotatable scalable skewable translatable></cropper-image>' + '<cropper-shade hidden></cropper-shade>' + '<cropper-handle action="select" plain></cropper-handle>' + '<cropper-selection initial-coverage="0.5" movable resizable>' + '<cropper-grid role="grid" bordered covered></cropper-grid>' + '<cropper-crosshair centered></cropper-crosshair>' + '<cropper-handle action="move" theme-color="rgba(255, 255, 255, 0.35)"></cropper-handle>' + '<cropper-handle action="n-resize"></cropper-handle>' + '<cropper-handle action="e-resize"></cropper-handle>' + '<cropper-handle action="s-resize"></cropper-handle>' + '<cropper-handle action="w-resize"></cropper-handle>' + '<cropper-handle action="ne-resize"></cropper-handle>' + '<cropper-handle action="nw-resize"></cropper-handle>' + '<cropper-handle action="se-resize"></cropper-handle>' + '<cropper-handle action="sw-resize"></cropper-handle>' + '</cropper-selection>' + '</cropper-canvas>';
var REGEXP_ALLOWED_ELEMENTS = /^img|canvas$/;
var REGEXP_BLOCKED_TAGS = /<(\/?(?:script|style)[^>]*)>/gi;
var DEFAULT_OPTIONS = {
  template: DEFAULT_TEMPLATE
};
CropperCanvas.$define();
CropperCrosshair.$define();
CropperGrid.$define();
CropperHandle.$define();
CropperImage.$define();
CropperSelection.$define();
CropperShade.$define();
CropperViewer.$define();

var Cropper = /*#__PURE__*/function () {
  function Cropper(element, options) {
    _classCallCheck(this, Cropper);

    var _a;

    this.options = DEFAULT_OPTIONS;

    if (isString(element)) {
      element = document.querySelector(element);
    }

    if (!isElement(element) || !REGEXP_ALLOWED_ELEMENTS.test(element.localName)) {
      throw new Error('The first argument is required and must be an <img> or <canvas> element.');
    }

    this.element = element;
    options = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    this.options = options;
    var _options = options,
        container = _options.container;

    if (container) {
      if (isString(container)) {
        container = (_a = getRootDocument(element)) === null || _a === void 0 ? void 0 : _a.querySelector(container);
      }

      if (!isElement(container)) {
        throw new Error('The `container` option must be an element or a valid selector.');
      }
    }

    if (!isElement(container)) {
      if (element.parentElement) {
        container = element.parentElement;
      } else {
        container = element.ownerDocument.body;
      }
    }

    this.container = container;
    var tagName = element.localName;
    var src = '';

    if (tagName === 'img') {
      var _element = element;
      src = _element.src;
    } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
      src = element.toDataURL();
    }

    var _options2 = options,
        template = _options2.template;

    if (template && isString(template)) {
      var templateElement = document.createElement('template');
      var documentFragment = document.createDocumentFragment();
      templateElement.innerHTML = template.replace(REGEXP_BLOCKED_TAGS, '&lt;$1&gt;');
      documentFragment.appendChild(templateElement.content);
      Array.from(documentFragment.querySelectorAll(CROPPER_IMAGE)).forEach(function (image) {
        image.setAttribute('src', src);
        image.setAttribute('alt', element.alt || 'The image to crop'); // Inherit additional attributes from HTMLImageElement

        if (tagName === 'img') {
          ['crossorigin', 'decoding', 'elementtiming', 'fetchpriority', 'loading', 'referrerpolicy', 'sizes', 'srcset'].forEach(function (attribute) {
            if (element.hasAttribute(attribute)) {
              image.setAttribute(attribute, element.getAttribute(attribute) || '');
            }
          });
        }
      });

      if (element.parentElement) {
        element.style.display = 'none';
        container.insertBefore(documentFragment, element.nextSibling);
      } else {
        container.appendChild(documentFragment);
      }
    }
  }

  _createClass(Cropper, [{
    key: "getCropperCanvas",
    value: function getCropperCanvas() {
      return this.container.querySelector(CROPPER_CANVAS);
    }
  }, {
    key: "getCropperImage",
    value: function getCropperImage() {
      return this.container.querySelector(CROPPER_IMAGE);
    }
  }, {
    key: "getCropperSelection",
    value: function getCropperSelection() {
      return this.container.querySelector(CROPPER_SELECTION);
    }
  }, {
    key: "getCropperSelections",
    value: function getCropperSelections() {
      return this.container.querySelectorAll(CROPPER_SELECTION);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a;

      var cropperCanvas = this.getCropperCanvas();

      if (cropperCanvas) {
        (_a = cropperCanvas.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(cropperCanvas);
      }

      if (this.element) {
        this.element.style.display = '';
      }
    }
  }]);

  return Cropper;
}();

Cropper.version = '2.1.0';
export { DEFAULT_TEMPLATE, Cropper as default };